import { useState } from "react";
import { AlertTriangle } from "react-feather";
import { Alerts, Btn, P } from "../../../../AbstractElements";

const DoubleOutline = () => {
  const [active, setActive] = useState(true);
  return (
    <Alerts color="transparent" isOpen={active} className={`txt-warning double-border border-warning alert-dismissible fade show alert-icons`}>
      <AlertTriangle />
      <P>{"The "}<b className="txt-warning">"double-border"</b>&<b className="txt-warning">"border-warning" </b>class has the ability to generate on its own alerts.</P>
      <Btn color="transperant" close onClick={() => setActive(false)} />
    </Alerts>
  );
};

export default DoubleOutline;
